<template>
  <el-tabs v-model="activeTab" @tab-click="changeTabCick">
    <el-tab-pane label="权限管理" name="roleAuthorityManage">
      <div class="permission-mgmt">
        <div class="header-box">
          <div class="header-line">
            <span class="header-label">状态</span>
            <el-select v-model="status" size="small">
              <el-option v-for="item in statusList" :key="item.status" :label="item.label" :value="item.status">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" v-on:click="getRoleAuthorityList">查询</el-button>
            <!--        <el-button type="primary" size="small" v-on:click="addNew">新增</el-button>-->
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%" cell-class-name="table-cell"
                  row-class-name="table-row" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="50px">
            <template slot-scope="scope">
              {{beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="角色" width="150px">
          </el-table-column>
          <el-table-column prop="authorityDescription" label="权限说明" width="550px">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80px">
            <template slot-scope="scope">
              <!--            v-model="scope.row[item.status]"-->
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="roleAuthoritySwitchChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <router-link :to="{path:'/client/resourceList/addOrEditPermission', query: {
          name: scope.row.roleName,
          authorityIdList: scope.row.authorityIdList,
          id: scope.row.id,
          status: scope.row.status,
          role: scope.row.role,
          }}" size="small" style="color: #5893ff;font-size: 12px;">编辑权限</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
    <el-tab-pane label="功能编辑" name="editAuthority">
      <div class="permission-mgmt">
        <div class="header-box">
          <div class="header-line">
            <span class="header-label">应用:</span>
            <el-select v-model="appType" size="small" @change="getPageList">
              <el-option label="后台管理系统" value="1"></el-option>
              <el-option label="贴标装箱系统" value="2"></el-option>
            </el-select>
            <span class="header-label">页面:</span>
            <el-select v-model="parentId" size="small" clearable>
              <el-option v-for="item in pageList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" v-on:click="getAuthorityList">查询</el-button>
            <el-button type="primary" size="small" v-on:click="addNewAuthority">新增</el-button>
          </div>
        </div>
        <el-table :data="authorityListData" border style="width: 100%" cell-class-name="table-cell"
                  row-class-name="table-row" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="50px">
            <template slot-scope="scope">
              {{beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="appName" label="所属应用" width="150px">
          </el-table-column>
          <el-table-column prop="parentName" label="所属页面" width="150px">
          </el-table-column>
          <el-table-column prop="name" label="功能" width="150px">
          </el-table-column>
          <el-table-column prop="resourceNames" label="接口" width="550px">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80px">
            <template slot-scope="scope">
              <!--            v-model="scope.row[item.status]"-->
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="authoritySwitchChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <router-link :to="{path:'/client/resourceList/addOrEditAuthority', query: {
          name: scope.row.name,
          resourceIdList: scope.row.resourceIdList,
          id: scope.row.id,
          status: scope.row.status,
          parentId: scope.row.parentId,
          appType: scope.row.appType,
          }}" size="small" style="color: #5893ff;font-size: 12px;">编辑功能</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
    <el-tab-pane label="接口编辑" name="editResource">
      <div>
        <div class="header-box">
          <div class="header-line">
            <span class="header-label">状态</span>
            <el-select v-model="status" size="small">
              <el-option v-for="item in statusList" :key="item.id" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
            <span class="header-label">名称</span>
            <el-input v-model="resourseName"></el-input>
            <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
            <el-button type="primary" size="small" v-on:click="addNewResource">新增</el-button>
          </div>
        </div>
        <el-table :data="resourseListData" border style="width: 100%" cell-class-name="table-cell"
                  row-class-name="table-row" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="50px">
            <template slot-scope="scope">
              {{beginIndex + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" width="150px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="accessUrl" label="url" width="550px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.accessUrl"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="typeStr" label="类型" width="100px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" size="small">
                <el-option v-for="item in resourceTypeList" :key="item.vlue" :label="item.label" :value="item.vlue">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="matchTypeStr" label="匹配类型" width="115px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.matchType" size="small">
                <el-option v-for="item in resourceMatchTypeList" :key="item.vlue" :label="item.label" :value="item.vlue">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80px">
            <template slot-scope="scope">
              <!--            v-model="scope.row[item.status]"-->
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="resourceSwitchChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button size="mini" type="success" icon="el-icon-check" @click="saveResource(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, next" background prev-text="上一页" next-text="下一页" :page-count="totalPage" @prev-click="prevBtnClick"
                       @next-click="nextBtnClick">
        </el-pagination>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import {
    permissionModules
  } from '@r'
  export default {

    data() {
      return {
        activeTab: 'roleAuthorityManage',
        statusList: [{
            status: "",
            label: "全部"
          },
          {
            status: "1",
            label: "有效"
          },
          {
            status: "0",
            label: "无效"
          }
        ],
        resourceTypeList:[
          {
            vlue: 1,
            label: "页面",
          },
          {
            vlue: 2,
            label: "数据",
          }
        ],
        resourceMatchTypeList:[
          {
            vlue: 1,
            label: "等值",
          },
          {
            vlue: 2,
            label: "最左匹配",
          }
        ],
        status: "",
        tableData: [],
        authorityListData: [],
        resourseListData: [],
        beginIndex: 0,
        pageSize: 20,
        totalPage: 1,
        currentPage: 1,
        parentId: null,
        pageList: [],
        resourseName: null,
        appType: "1",
      }
    },
    activated() {
      this.getRoleAuthorityList();
      this.getPageList();
    },
    methods: {
      getPageList(){
        permissionModules.getPageAuthorityList({
          appType: this.appType,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }
          this.pageList = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      changeTabCick(tab, event) {
        if(tab.name == 'editAuthority'){
          this.getAuthorityList();
        }
        if(tab.name == 'editResource'){
          this.getResourceList();
        }
      },
      getDisplayType(row) {
        var typeLabel = "--";
        row.type == "PAGE" && (typeLabel = "页面");
        row.type == "DATA" && (typeLabel = "数据");
        return typeLabel
      },
      getDisplayMatchType(row) {
        var typeLabel = "--";
        row.matchType == "1" && (typeLabel = "等值");
        row.matchType == "2" && (typeLabel = "最左匹配");
        return typeLabel
      },
      prevBtnClick() {
        if (this.beginIndex <= 0) {
          this.$message({
            type: 'info',
            message: '已经到头了!'
          })
          return;
        }
        this.beginIndex = this.beginIndex - this.pageSize;
        this.getResourceList();
      },
      nextBtnClick() {
        if (this.resourseListData.length < this.pageSize) {
          this.$message({
            type: 'info',
            message: '没有更多了!'
          })
          return;
        }
        this.beginIndex = this.beginIndex + this.pageSize;
        this.getResourceList();
      },
      onQueryBtnClick(){
        this.beginIndex = 0
        this.getResourceList();
      },
      getRoleAuthorityList() {
        permissionModules.getRoleAuthorityList({
          status: this.status,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }

          this.tableData = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      getAuthorityList() {
        permissionModules.getAuthorityList({
          parentId: this.parentId,
          appType: this.appType,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }

          this.authorityListData = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      getResourceList() {
        permissionModules.getResourceList({
          status: this.status,
          beginIndex: this.beginIndex,
          pageSize: this.pageSize + 1
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }
          this.resourseListData = res.ldata;
          this.currentPage = this.beginIndex / this.pageSize + 1;
          if (this.resourseListData.length >= this.pageSize) {
            this.resourseListData.pop();
            this.totalPage = this.currentPage + 1;
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      addNewAuthority() {
        var info={
          status: 1,
          appType: 1,
        }
        this.$router.push({path:'/client/resourceList/addOrEditAuthority', query: info});
      },
      roleAuthoritySwitchChange(row){
        if(row.id == null){
          this.$message({
            type: 'error',
            message: '该角色还未创建对应功能关系，请先编辑权限后操作'
          });
          row.status = row.status == 0? 1:0;
          return;
        }
        permissionModules.editRoleAuthority({
          id: row.id,
          status: row.status,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: "编辑成功"
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      authoritySwitchChange(row){
        permissionModules.editAuthority({
          id: row.id,
          status: row.status,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: "编辑成功"
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      resourceSwitchChange(row){
        permissionModules.addOrEditResource({
          resourceId: row.resourceId,
          status: row.status,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: "编辑成功"
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      saveResource(row){
        permissionModules.addOrEditResource(row).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: "编辑成功"
          });
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      addNewResource(){
        this.resourseListData.unshift({
          id:null,
          name: null,
          accessUrl: null,
          type: 1,
          matchType: 1,
          status: 1,
        });
      }
    }
  }
</script>

<style lang="scss">
  .header-box {
    .el-button {
      width: auto;
    }
  }
</style>
